{
    "apiFailDefaultMsg": "Något gick fel. Försök igen senare.",
    "more": "Flera",
    "searchResult": "Sökresultat",
    "showAll": "Visa alla",
    "showRelevant": "Visa relevanta",
    "assistantTabTooltip": "Assistance besvarar dina frågor genom att söka i E.ON:s interna resurser i realtid. Den ger tydliga, lättförståeliga svar med källor så att du kan lita på informationen",
    "searchTabTooltip": "E.ON Search är en traditionell sökfunktion som hjälper dig att snabbt hitta information från olika E.ON-källor och dina egna data. Den ger de mest relevanta resultaten och länkar till källorna",
    "appData": {
        "approval": "Mina godkännanden",
        "approvalhover": "Med myInbox kan du enkelt och effektivt godkänna fakturor genom att ha all relevant information och åtgärder samlade på ett ställe.",
        "ariba": "Ariba - Classic och Classic+",
        "aribahover": "Med SAP Ariba kan du enkelt hantera dina inköpsprocesser genom att ha all relevant information och alla verktyg samlade på ett ställe.",
        "beeline": "Beeline",
        "beelinehover": "Med Beeline kan du effektivt hantera din tillfälliga personal och effektivisera dina bemanningsprocesser genom att ha alla nödvändiga verktyg och information samlade på ett ställe.",
        "eon_brand": "E.ON Brand Space",
        "eon_brandhover": "E.ON Brand Space",
        "concur": "Concur för rese- och utgiftshantering",
        "concurhover": "Med Concur kan du enkelt hantera och skicka in dina rese- och utgiftsrapporter genom att samla all relevant information och alla åtgärder på ett ställe.",
        "gertrud": "Gertrud",
        "gertrudhover": "Gertrud",
        "hr": "HR-portal",
        "hrLabel": "HR-portal",
        "hrhover": "Med myHR kan du enkelt komma åt och hantera din HR-relaterade information och dina uppgifter på ett ställe.",
        "incident": "Incidenter",
        "incidenthover": "Incidenter",
        "itresources": "IT-resurser",
        "itresourceshover": "IT-resurser",
        "journey": "Resor/Event",
        "journeyhover": "Resor/Event",
        "mail": "E-postlista",
        "mailhover": "E-postlista",
        "meeting": "Bokning av mötesrum",
        "meetinghover": "Med Gingco, vårt verktyg för rumsbokning, kan du enkelt hantera och schemalägga dina mötesrum och resurser, vilket säkerställer effektivt utnyttjande och god tillgänglighet, allt på ett ställe.",
        "myassets": "Mina tillgångar",
        "myassetshover": "Mina tillgångar",
        "mygenius": "MyGenius",
        "mygeniushover": "MyGenius",
        "notification": "Aviseringsportal",
        "notificationhover": "Aviseringsportal",
        "order": "Beställning",
        "orderhover": "Beställning",
        "password": "Återställning av SAP-lösenord",
        "passwordhover": "Med den här funktionen kan du enkelt återställa åtkomstlösenorden för dina SAP-system.",
        "pki": "PKI-portalen",
        "pkihover": "PKI-portalen",
        "pr": "Skapa inköpsrekvisition",
        "pra": "Skapa avancerad inköpsrekvisition",
        "prahover": "Här hittar du alla relevanta funktioner för att begära varor och tjänster. Detta kallas även BANF (inköpsrekvisition).",
        "prhover": "Här hittar du alla relevanta funktioner för att begära varor och tjänster. Detta kallas även BANF (inköpsrekvisition).",
        "prisma": "Prisma",
        "prismahover": "PRISMA står förPlatform for Reporting on Incident and Sustainability Management and Auditing. Plattformen stödjer E.ON:s HSE-avdelning i dess uppdrag att göra E.ON till en hälsoinriktad, säker och miljömedveten arbetsplats. PRISMA är tillgänglig både via webben och som app.",
        "processing": "Min inkorg",
        "processinghover": "Med myInbox kan du enkelt och effektivt godkänna fakturor genom att ha all relevant information och alla åtgärder samlade på ett ställe.",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Personnel file - Digital Personnel File - DPF",
        "corpsac": "Corporate SAC",
        "corpportal": "Corporate Portal",
        "redwood": "Redwood Finance Automation",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Banking: Bank Acc Mgmt (EBAM)",
        "egs": "E.ON Guarantee Solution",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Risk Management",
        "slido": "Slido",
        "insightslibrary": "Insights Library",
        "getabstract": "getAbstract",
        "mypotential": "Achieving My Potential",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Whistleblowing Solution",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Vorfallsmeldung",
        "cateringportal": "Speiseplan",
        "westnetzregelwerke": "Regelwerke Westnetz",
        "werbemittel": "Werbemittel",
        "westenergie_brand": "Brand-Management-Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM and ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "ideeonhover": "Idee.on är en plattform som gör det möjligt för anställda att lämna och utvärdera idéer och förslag. Plattformen är utformad för att underlätta en kontinuerlig förbättringsprocess inom alla områden av företaget.",
        "ideenethover": "IdeeNet är ett idéhanteringssystem i ordets rätta bemärkelse. En mängd olika idéer, till exempel: &#10;&bull; Centraliserad BVW, decentraliserad BVW och blandade former &#10;&bull; Kvalitetscirklar och CIP &#10;&bull; Felanmälningar och reklamationer &#10;&bull; Anställdas uppfinningar &#10;kan hanteras effektivt med denna programvara, i en enhetlig idédatabas, men med olika strategier.",
        "dpfhover": "Din personalmapp innehåller betydligt fler dokument än de som visas permanent i MyHR! &#10;Skicka in en HR-förfrågan och begär tillgång till hela din personalmapp! Efter en professionell granskning kommer den att göras tillgänglig för dig via en direktlänk.",
        "corpsachover": "SAC är ett kraftfullt visualiseringsverktyg med avancerade planeringsmöjligheter",
        "corpportalhover": "Företagsportalen är en central intern applikationsplattform med rollbaserad applikationsintegration och utveckling för Single-Sign-On-åtkomst till SAP-serverdelar.",
        "redwoodhover": "redwood FA används för att schemalägga de konsoliderade finansiella rapporterna och automatisera individuella aktiviteter",
        "eamsap200hover": "Enterprise Asset Management &#10;Miljö för egenutveckling baserad på Business technology platform (BTP) från SAP (tidigare SAP Cloud Plattform) - EAM-konto för nätcockpits, inklusive molninstanser: produktion, QA (Quality Assurance), utveckling och staging",
        "eamsap100hover": "Enterprise Asset Management &#10;Miljö för egenutveckling baserad på Business technology platform (BTP) från SAP (tidigare SAP Cloud Plattform) - EAM-konto för nätcockpits, inklusive molninstanser: produktion, QA (Quality Assurance), utveckling och staging",
        "sodsaphover": "SOD-portalen är utformad för att effektivisera och digitalisera hanteringen av ansvarsfördelning (SOD). Genom att digitalisera identifiering, övervakning och lösning av SOD-konflikter säkerställer den efterlevnad av regulatoriska standarder och förbättrar organisationens säkerhet. Detta verktyg är viktigt för att upprätthålla ett robust internt kontrollsystem och skydda din affärsverksamhet.",
        "videonhover": "App för att boka tjänster från video/TV-studion på Brüsseler Platz för en video/TV-produktion eller ett streamingevenemang.",
        "alteryxhover": "Plattform för dataanalys som används för att skapa analysprogram och arbetsflöden. Det gör det möjligt för användare att hantera och dela analysapplikationer, köra arbetsflöden och komma åt och rapportera om utdata i en servermiljö",
        "ebamhover": "Elektronisk bankkontohantering",
        "egshover": "E.ON SE tar över borgen och garantier för BU:er i gruppen till externa långivare",
        "epsnexthover": "Central elektroniskt bankverktyg för alla MU/Bus",
        "fisquantumhover": "FIS Quantum Treasury Management Solution är utformad för att förbättra effektiviteten och ändamålsenligheten i din organisations finansverksamhet. Denna molnbaserade plattform ger insyn i realtid i kontanter och likviditet, vilket möjliggör bättre beslutsfattande om kapital- och riskhantering. Med avancerade funktioner för att hantera skulder, investeringar och efterlevnad hjälper det till att effektivisera arbetsflöden och förbättra det ekonomiska resultatet.",
        "rmshover": "E.ON:s koncerngemensamma riskhanteringssystem (kredithanteringssystem och kreditriskhanteringssystem)",
        "slidohover": "Slido är en interaktiv plattform utformad för att förbättra publikens engagemang och samla insikter under live eller virtuella evenemang, möten och presentationer. Den möjliggör genomförande av undersökningar, Q&A-sessioner och frågesporter i realtid, vilket skapar en dynamisk  upplevelse för publiken och uppmuntrar till deltagande.",
        "insightslibraryhover": "Insights Library är E.ON:s centrala kunskapsdatabas för kund- och marknadsinsikter inom kundlösningsverksamheten.",
        "getabstracthover": "getAbstract är E.ONs koncernövergripande onlinebibliotek, som tillhandahålls av getAbstract, med boksammanfattningar, artiklar och vidareutbildningsformat som täcker alla affärsrelevanta färdigheter (mjuka som funktionella)",
        "mypotentialhover": "System för anställda och chefer i Storbritannien att registrera deras prestationer, mål och omdömme.",
        "dsesoftwarehover": "Skärmträning och bedömningar för hälsa och säkerhet",
        "whistleblowinghover": "Visselblåsningsverktyget gör det möjligt för alla som lämnar information att lämna in en anmälan anonymt. Detta kan göras via webbintag, e-post eller telefon. Under ett samtal kommer din röst att förvrängas.",
        "maqsimahover": "Hantering av riskbedömningar, driftinstruktioner, farliga ämnen &#10;Maqsima hjälper dig att hålla koll på alla relevanta riskbedömningar och driftinstruktioner samt hålla dem uppdaterade på ett smart sätt",
        "digitalrulebookhover": "Paula Policy är den AI-baserade assistenten för E.ONs företagspolicyer och ger medarbetare snabb och enkel tillgång till People Guidelines, Function Policies och Code of Conduct. Den ger konsekventa och tillförlitliga svar och gör komplexa policyer lättförståeliga och tillgängliga.",
        "oneERPhover": "one.ERP Portal är en central plattform inom Westenergie-koncernen som samlar olika ERP-relaterade funktioner och information. Den fungerar som en informations- och kontrollcentral för ERP-användare och IT-chefer och är en del av koncernens övergripande digitaliseringsstrategi.",
        "Perseushover": "Säkerhetsportalen är en central åtkomstpunkt för rapportering av säkerhetsrelaterade incidenter inom organisationerna Westenergie och Westnetz. Den används ofta tillsammans med det interna rapporteringssystemet Perseus, som är särskilt utformat för att hantera incidenter som förlust av enheter, stöld eller dataskyddsöverträdelser.",
        "cateringportalhover": "Portalen eon.cateringportal.io är den digitala plattformen för E.ON Canteen App. Den tillhandahåller måltidsplaner, platsinformation och andra cateringtjänster för E.ON:s anställda.",
        "westnetzregelwerkehover": "Denna portal fungerar som en central resurs för tekniska föreskrifter och dokumentation relaterad till drift och förvaltning av el- och gasnäten. Den säkerställer att alla relevanta riktlinjer, standarder och tekniska specifikationer som krävs för säker och effektiv nätdrift är tillgängliga.",
        "werbemittelhover": "Westenergie Promotional Items Shop är en onlineplattform där anställda och auktoriserade partners inom Westenergie-koncernen kan beställa reklamprodukter och kommunikationsmaterial.",
        "westenergie_brandhover": "Westenergies bilddatabas samt varumärkeselement och designriktlinjer för Westenergie-koncernen. Tillgång till alla delar av vårt varumärke för att skapa Westenergie-upplevelser. Från varumärkeshanteringssystemet med alla viktiga riktlinjer för användning av varumärkeselement som logotyper, symboler och vår chattbox till mediebiblioteket med ett stort antal bilder för alla designvarianter.",
        "compasshover": "Compass är den koncernövergripande interna kommunikationsplattformen för E.ONs nyheter och innehåll, nätverkande och medarbetarutbyte.",
        "gradarhover": "Detta verktyg används för att starta jobbgraderingsprocessen för anställda.",
        "beqomhover": "beqom används för administration och kommunikation av E.ONs långsiktiga incitamentsplaner. Det används av HR, Redovisning, Skatt och av chefer. Förutom långsiktiga incitamentsplaner kan beqom också användas för att skapa löne- och bonusbrev samt totala belöningsdeklarationer.",
        "kychover": "Med verktyget Know-Your-Counterpart (KYC) kan du screena motparter enligt standardpolicyer (t.ex. PG-03).",
        "talentryhover": "En möjlighet att dela våra aktuella jobbmöjligheter med talanger i ditt nätverk – människor som vill hjälpa till att forma framtiden.",
        "samhover": "Du kan genomföra obligatoriska säkerhetsutbildningar med detta verktyg.",
        "enormhover": "e-NORM är en kraftfull programvara för att hantera, tillhandahålla och uppdatera data relaterad till kvalitetssäkring eller standarddokument, samt länka associerade filer.",
        "redonlinehover": "Red-on-line (ROL) Compliance Monitor förenklar hanteringen av regelefterlevnad genom att tillhandahålla uppdateringar i realtid om miljö-, hälso- och säkerhetsföreskrifter (EHS). Den har övervakning och instrumentpaneler som hjälper dig att proaktivt ta itu med efterlevnadsproblem. Detta verktyg är viktigt för att upprätthålla en säker och kompatibel arbetsplats, minska riskerna och förbättra den operativa effektiviteten.",
        "tagetikcpmhover": "Tagetik Corporate Performance Management (CPM) applikation för budgetering och planering, konsolidering, risk- och ledningsrapportering (introducerad av Finance Excellence) från E.ON SE (Group Reporting). Huvudprocesserna är de kvartalsvisa boksluten som har en mycket hög extern påverkan på grund av en hård deadline för kapitalmarknadskommunikation.",
        "tagetikcpmermhover": "Tagetik Corporate Performance Management (CPM) och Enterprise Risk Management (ERM) applikation för budgetering och planering, konsolidering, risk och ledningsrapportering (introducerad av Finance Excellence) från E.ON SE (Group Reporting). Huvudprocesserna är de kvartalsvisa boksluten som har en mycket hög extern påverkan på grund av en hård deadline för kapitalmarknadskommunikation.",
        "smartguidehover": "The Smart Guide Hub är en wiki som administreras av E.ON medarbetare för att tillhandahålla riktlinjer för cirka 4000 användare inom områdena IFRS, Controlling, HGB och ESG.",
        "tagetiksachover": "Tagetik Dashboard. Tagetik är en applikation för budgetering och planering, konsolidering, risk- och ledningsrapportering (introducerad av Finance Excellence) från E.ON SE (Group Reporting). Huvudprocesserna är de kvartalsvisa boksluten som har en mycket hög extern påverkan på grund av en hård deadline för kapitalmarknadskommunikation.",
        "myithover": "Din kontaktperson för allt som rör IT: supportalternativ, användbara länkar, communities och de senaste nyheterna du behöver veta.",
        "servicehub": "Service Hub",
        "servicehubhover": "Med EON Service Hub kan du enkelt begära ny mjukvara och hårdvara, inklusive bärbara datorer och bildskärmar, samt få IT-support genom att rapportera problem eller chatta med my IT support – allt samlat på ett ställe.",
        "SailPoint": "Identity Management Overview",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Fuhrparkmanagement",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Med SailPoint kan åtkomsträttigheter och identiteter hanteras centralt.",
        "P29hover": "Med SAP EIC kan ärenden och kundförfrågningar hanteras och dokumenteras effektivt. Applikationen stöder utbyte med ECG och erbjuder ett centralt gränssnitt för ärendehantering.",
        "P83hover": "Med SAP EIC kan ärenden och kundförfrågningar hanteras och dokumenteras effektivt. Applikationen stöder utbyte med ECG och erbjuder ett centralt gränssnitt för ärendehantering.",
        "BIChover": "Med BIC Cloud kan affärsprocesser modelleras, analyseras och optimeras.",
        "Celonishover": "Process Mining: Analys av faktiska processer baserat på händelselogg från ERP-, CRM- och andra system. Execution Management: Automatisering av arbetsflöden och rekommendationer för åtgärder. Processoptimering: Identifiering av ineffektivitet, t.ex. i Purchase-to-Pay eller Order-to-Cash-processer. Integration: Anslutning till system som SAP, Salesforce, Oracle, etc.",
        "Carsynchover": "Med Carsync kan företagsbilar och fordonsflottor hanteras effektivt, resor dokumenteras och kostnader optimeras.",
        "ISUSpacehover": "Med ISU/Space kan arbetsplatser och mötesrum enkelt bokas och hanteras.",
        "GNIShover": "Med GNIS kan masterdata och nätdata för marknadskommunikation (EDI) hanteras och utbytas effektivt.",
        "ecount_EDIhover": "Med eccount kan EDI-relaterade masterdata och nätdata hanteras, utbytas och analyseras.",
        "SAP_Datasphere_EDIhover": "Med SAP Datasphere kan data från olika källor integreras, modelleras och göras tillgängliga för analys och affärsbeslut. Plattformen stöder självbetjäning, datastyrning och realtidsåtkomst till data.",
        "ukhr": "UK HR App",
        "ukhrhover": "Your one stop shop for everything UK HR. From payslips to holiday booking and everything in between. Get started with our employee and manager guides or search all of HR below.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Central ingångspunkt för SAP-system och molntjänster.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition gör det möjligt att skapa digitala arbetsplatslösningar för att öka användarnas produktivitet och engagemang. Den centraliserar åtkomst till relevanta affärsapplikationer, processer, information och kommunikation i en gemensam ingångspunkt som användare kan nå från vilken enhet som helst.",
        "SAPWebLaunchpadhover": "SAP Web Launchpad ger åtkomst till SAP-system via webben med Fiori och WebGUI. Den anpassningsbara startsidan, inklusive favoriter, möjliggör snabb åtkomst till SAP-system och klienter.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digital signatur",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Personalutvärdering EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Felanmälningar fastighetsförvaltning EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Affärsresor EER",
        "Users_Access_EER_5369": "Användaråtkomst EER",
        "Planificare_Concedii_EER_8588": "Semesterplanering EER",
        "Pontaje_si_Telemunca_EER_7087": "Tidrapportering och distansarbete EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Personalbonus",
        "GRC_Request_5510": "GRC-begäran",
        "iPEN_Portal_3047": "iPEN-portal",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT-Portal (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "Rapportera IT-säkerhetsincident VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "Rapportera HSE-incident VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Meny VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT-anmälningsformulär VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Intyg och andra HR-applikationer (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Utgiftsredovisning med företagskort (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Resedokument (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Återställ token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portal för personalutvärdering EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portal för felanmälningar inom fastighetsförvaltning EER",
        "MRBS_EER_8445hover": "Bokning av mötesrum EER",
        "Delegatii_EER_1137hover": "Portal för affärsresor EER",
        "Users_Access_EER_5369hover": "Formulär för användaråtkomst EER",
        "Planificare_Concedii_EER_8588hover": "Semesterplanering EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Tidrapportering och distansarbete EER",
        "BOT_6231hover": "Ersättning för vilo- och behandlingsbiljetter",
        "Bonusare_personal_6879hover": "Personalbonus",
        "GRC_Request_5510hover": "GRC står för Governance & Risk Compliance Access Control och är ett SAP-workflowverktyg för automatiserad ansökan, godkännande och tilldelning av användarbehörigheter i SAP-system.",
        "iPEN_Portal_3047hover": "Information Platform of Energy Networks, förkortat iPEN, säkerställer att data från regionala enheter kan samlas och tillhandahållas centralt. Befintliga och nyutvecklade intelligenta lösningar ansluts till plattformen. Därmed kan de rullas ut kostnadseffektivt, snabbt och flexibelt i hela nätgemenskapen. iPEN är därför den centrala möjliggöraren för skalning av intelligenta lösningar.",
        "YourVoiceEON_0693hover": "Plattformen PEAKON skickar cirka 4-5 frågor till dig en gång i veckan om aspekter av ditt välbefinnande och din nuvarande arbetssituation. Du kan betygsätta frågorna (från 0 till 10), kommentera dem eller hoppa över dem. Att besvara de få frågorna tar bara cirka 1-2 minuter.",
        "ITPortal_5530hover": "Süwags IT-serviceportal",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Meny",
        "Ariba_8690hover": "Inköpsportal",
        "DiSch_20_0545hover": "Detta ar min digitala arbetsplats",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Süwags Confluence",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Tidsrapportering",
        "CTP_2407hover": "CTP (Tid är pengar)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Stöd för affärsprocesshantering med Jira",
        "Qmatic_PL_CS_3195hover": "Applikation för att hantera kundflöde (köer) i kassasystem (POS)",
        "Qmatic_PL_EN_3118hover": "Applikation för att hantera kundflöde (köer) i kassasystem (POS)",
        "CCM_Inspire_7264hover": "E.ON:s centraliserade plattform för hantering av kundkommunikation (CCM), driven av Quadient Inspire, för att skapa och leverera kundkommunikation.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Detta är vårt tidrapporteringssystem",
        "Atoss_VSEGruppe_4374hover": "Detta är vårt tidrapporteringssystem",
        "AWS_Access_Portal_1318hover": "Åtkomst till AWS-konton",
        "eDIVA_5372hover": "ANF-användarhantering",
        "G2G_VSEGruppe_6518hover": "GIS-system för VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Åtkomst till AWS Cloud för VSE-Gruppe",
        "Qualys_Security_4331hover": "Övervakning av företagsrisker",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Rapportera IT-säkerhetsincident VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Rapportera HSE-incident VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Meny VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT-anmälningsformulär VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Instruktioner",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Syftet med den här applikationen är att låta varje användare ladda ner olika typer av intyg med högst tre klick. HR-administratörer och teamkoordinatorer kan även ladda ner intyg åt de kollegor de ansvarar för. Medarbetare kan dessutom beräkna sin anställningstid och pensionsstöd samt begära andra dokument från HR-avdelningen.",
        "Deconturi_card_companie_RO_CS_5333hover": "Innehavare av företagskort kan enkelt skicka in utläggsredovisningar via den här applikationen, utan att skicka kvitton via e-post eller post eller begära godkännanden via e-post. Hela processen sker på den här plattformen.",
        "Documente_delegatii_RO_CS_5332hover": "Med applikationen för hantering av tjänsteresor kan användare lägga till dokument till sina egna resor och sina medarbetares resor. HR-administratörer kan visa, filtrera och avsluta dokument i grupp samt begära ytterligare dokument via automatiskt skickade e-postmeddelanden.",
        "SAP_ISU_CS_RO_8555hover": "Tjänsten omfattar aktiviteter relaterade till SAP IS-U x7G-system som används av E.ON RO CS.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Förnya / Återställ token",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portal för personalutvärdering EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portal för felanmälningar inom fastighetsförvaltning EER",
            "MRBS_EER_8445subTitle": "Bokning av mötesrum EER",
            "Delegatii_EER_1137subTitle": "Portal för affärsresor EER",
            "Users_Access_EER_5369subTitle": "Formulär för användaråtkomst EER",
            "Planificare_Concedii_EER_8588subTitle": "Semesterplanering EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Tidrapportering och distansarbete EER",
            "BOT_6231subTitle": "Ersättning för vilo- och behandlingsbiljetter",
            "Bonusare_personal_6879subTitle": "Personalbonus",
            "GRC_Request_5510SubTitle": "GRC-begäran",
            "iPEN_Portal_3047SubTitle": "Informationsplattform för energinätverk",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Bokning av arbetsplatser",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Inköpsportal",
            "DiSch_20_0545SubTitle": "Digital arbetsplats",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Spårning av affärsaktivitet",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Affärsprocesshantering",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Plattform",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA ANF-användarhantering -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "Rapportera IT-säkerhetsincident VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "Rapportera HSE-incident VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Meny VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT-anmälningsformulär VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Intyg och andra HR-applikationer (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Utgiftsredovisning med företagskort (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Resedokument (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Central Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Länkar till SAP-system",
            "approvalSubTitle": "SNOW/SAP",
            "aribaSubTitle": "PO-översikt",
            "beelineSubTitle": "Extern uthyrning",
            "eon_brandSubTitle": "det är på oss",
            "concurSubTitle": "SAP Concur",
            "gertrudSubTitle": "Förbered styrelsemöten",
            "hrSubTitle": "MyHR",
            "incidentSubTitle": "SNOW",
            "itresourcesSubTitle": "SNOW",
            "journeySubTitle": "FuV §37b EstG",
            "mailSubTitle": "Underhåll",
            "meetingSubTitle": "GINGCO",
            "myassetsSubTitle": "SNOW",
            "mygeniusSubTitle": "Digital lärplattform",
            "notificationSubTitle": "Facility Services",
            "orderSubTitle": "Beställ IT-tjänster",
            "passwordSubTitle": "SAP-system",
            "pkiSubTitle": "Hantera certifikat",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "prismaSubTitle": "HSE",
            "processingSubTitle": "SAP",
            "timeSubTitle": "CATS",
            "zukoSubTitle": "Organisera kontorsflytt",
            "ideeonSubTitle": "Ideenmanagement",
            "ideenetSubTitle": "Idéhantering",
            "dpfSubTitle": "Digital personalmapp",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Företagsportal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Kunskapsdatabas",
            "getabstractSubTitle": "Bibliotek på nätet",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON visselblåsarlösning",
            "maqsimaSubTitle": "Hantering av riskbedömningar",
            "digitalrulebookSubTitle": "Riktlinjer för koncernen",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Werbemittelshop",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Koncernövergripande intern kommunikationsplattform",
            "gradarSubTitle": "Jobbutvärdering och ersättning",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Efterlevnad motpartskontroll",
            "talentrySubTitle": "Job referral program",
            "samSubTitle": "Säkerhetsutbildning @E.On",
            "enormSubTitle": "Efterlevnadsövervakning",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM and ERM",
            "smartguideSubTitle": "Smart Guide Hub (Redovisningswiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "IT-support och nyheter",
            "SailPointSubTitle": "Identitets- och åtkomsthantering – översikt",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Processbrytning",
            "CarsyncSubTitle": "Fordonsparkhantering",
            "ISUSpaceSubTitle": "Arbetsplats- och rumsförvaltning",
            "GNISSubTitle": "EDI-masterdatahantering",
            "ecount_EDISubTitle": "EDI-datamanagement",
            "SAP_Datasphere_EDISubTitle": "Dataintegration och affärsdataarkitektur",
            "ukhrSubTitle": "UK HR App"
        },
        "time": "Tidsspårning",
        "timehover": "Med CATS-appen kan du enkelt spåra och hantera dina arbetstimmar och aktiviteter genom att samla all relevant information och alla funktioner på ett ställe.",
        "zuko": "Zuko",
        "zukohover": "Zuko"
    },
    "cancel": "Avbryt",
    "chatBot": {
        "contactNumberPlaceholder": "Kontaktnummer med landskod",
        "incidentDetailsLabel": "Sammanfattning av händelsen",
        "contactNumberLabel": "Ange ditt önskade kontaktnummer",
        "sourceName": "Källa",
        "aiAssitanceSuggestion": "Du kan ställa dina frågor till AI Assistance genom att använda inmatningsrutan nedan.",
        "aiActionMsg": "Det verkar som om ditt interna minne är fullt. Jag kan hjälpa dig att lösa installationsproblemet genom att automatiskt rengöra dina temporära filer och tömma papperskorgen. Vill du att jag ska städa automatiskt?",
        "aiActionPrimaryBtn": "städa automatiskt",
        "aiActionSecondaryBtn": "städa inte automatiskt",
        "aiActionSuccess": "Din lagring har rensats.",
        "aiActionFailed": "Något gick fel. Försök efter en stund. Eller försök manuellt.",
        "appreciateService": "Vi uppskattar din hjälp med att förbättra våra tjänster.",
        "askEon": "Fråga E.ON",
        "askInternet": "Fråga Internet",
        "askMe": "Ställ dina frågor",
        "imageUpload": "Ladda upp bild",
        "uploadImageTooltip": "Ladda upp bild och ställ en fråga.",
        "uploadImageFormat": "Stödda format: JPG/PNG",
        "uploadImageProcessing": "Bearbetar bild...",
        "uploadImageQuestions": "Förslag på frågor:",
        "askTooltip": {
            "eon": "Få företagsspecifik information från interna källor",
            "internet": "Få information från interna och externa källor som E.ON GPT"
        },
        "card": {
            "efficiency": "Effektivitet",
            "ngService": "Nästa generations service",
            "selfService": "Självbetjäning"
        },
        "chatBotTitle": "Använd MyHelp Assistance för att ställa en fråga, få support eller för att söka efter information från interna och externa källor.",
        "chatIcon": "ChatBot",
        "chatbotPlaceholder": "Skriv här...",
        "complete": "Fullständig",
        "confirmCreateIncident": "Bekräfta och skapa incident",
        "content": "Innehåll",
        "copyLink": "Kopiera länk",
        "createIncident": "Skapa incident",
        "creatingIncident": "Skapar en incident",
        "differentiator": "eller",
        "disclaimerText": "Assistans kan generera innehåll som är felaktigt och bristfälligt. Kontrollera viktig information.",
        "duplicateError": "Dubblettfråga, vänligen ställ en annan fråga",
        "editCreateIncident": "Redigera och skapa incident",
        "feedbackMessage": "Tack för din återkoppling!",
        "feedbackMsg": "",
        "feedbackPrompt": "Återkoppla här",
        "feedbackTitle": "Var detta till hjälp?",
        "feedbackThumbsUpLabel": "Ja, det hjälpte",
        "feedbackThumbsDownLabel": "Behöver du fortfarande hjälp?",
        "hey": "Hej",
        "incident": "Raise Service ticket",
        "incorrectInformation": "Felaktig information",
        "information": "Information",
        "internetSearchContent": "Baserat på fråga mig något E.ON GPT",
        "assignmentGroupForTicket": "eon-se-gsd",
        "copy": "Kopiera",
        "share": "Dela",
        "copiedMsg": "Kopierad framgångsrikt",
        "sharableLink": "Delbar länk",
        "copyLinkMsg": "Kopiera länk",
        "uploadImage": "Ladda upp bild och ställ en fråga",
        "internetSearchTitle": "Allmänna frågor",
        "irelevantContent": "Irrelevant innehåll",
        "knowledgeBaseContent": "Förbättra medarbetarupplevelsen genom information",
        "knowledgeBaseTitle": "Kunskapsbas",
        "lackOfDetail": "Brist på detaljer",
        "liveAgent": "Chat with an agent",
        "requestCallbackBtn": "Request Callback",
        "liveAgentChat": {
            "agentLeftMsg": "Tack för att du kontaktade E.ON",
            "callback": "Begär återuppringning från my IT support",
            "chat": "Chatta med my IT support",
            "connectWithLiveAgent": "Anslut till my IT support",
            "connectingHint": "Du kan återgå till assistenten genom att klicka på länken under chattrutan.",
            "connectingWithLiveAgent": "Ansluter till my IT support...",
            "heading": "Snabba åtgärder",
            "help": "Hjälp mig lösa ett IT-problem",
            "switchToAssistance": "Exit chat and switch to assistance",
            "typeMessageHint": "Skriv ditt meddelande här...",
            "disconnectingMsg": "Avslutar chatten med servicedesk och växlar tillbaka till AI-assistenten",
            "continue": "Fortsätt",
            "exitChat": "Lämna chat",
            "chatSessionEndPrompt": "Chattsessionen avslutas automatiskt om <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "MyHelp Assistance har upptäckt att ditt standardspråk är “<language>”. Bekräfta för att bli kopplad till en agent eller ändra önskat språk och agenttyp nedan.",
            "channelsText": "Ta emot återuppringning via",
            "languageText": "Kommunikationsspråk",
            "channelLabel": "Välj kanal",
            "phoneLabel": "Koppla upp mig via",
            "languageLabel": "Välj språk",
            "tryAgain": "Försök igen",
            "technicalIssue": "Det gick inte att genomföra din återuppringning på grund av ett tekniskt fel. Försök igen.",
            "addNewNumber": "Nytt nummer",
            "availableMobileNumbers": "Tillgängliga mobilnummer",
            "chosenNumber": "Koppla upp mig på detta nummer",
            "phoneError": "Ange ett giltigt telefonnummer",
            "referenceNumber": "Referensnummer",
            "tooltip": {
                "confirmBtn": "Bekräfta för att lägga en begäran om återuppringning",
                "resetBtn": "Återställ formuläret och börja om",
                "cancelBtn": "Avbryt återuppringning"
            },
            "newNumber": "Nytt nummer"
        },
        "newChat": "Ny chatt",
        "search": "E.ON Search",
        "open": "Öppna",
        "close": "Stäng",
        "recentChats": "senaste chattarna",
        "ask": "Fråga",
        "internet": "Internet",
        "askFollowUpQuestion": "Ställ en uppföljande fråga",
        "openLink": "Öppna länk",
        "other": "Annat",
        "privacyMsg": "Vi respekterar din integritet och försäkrar att din feedback hanteras konfidentiellt.",
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Skapa ärende",
                "chatWithServiceDesk": "Starta livechatt",
                "requestCallback": "Begär återuppringning",
                "ongoingConversation": "Ja, det är en del av min senaste konversation.",
                "newConversation": "Nej. Jag behöver hjälp med att lösa ett nytt problem.",
                "confirmAndCreateTicket": "Bekräfta och skapa ärende",
                "cancelTicketCreation": "Avbryt ärendeskapande",
                "confirmChatWithServiceDesk": "Bekräfta och anslut till my IT support",
                "cancelChatWithServiceDesk": "Avbryt chat med my IT support",
                "cancelRequestCallback": "Avbryt begäran om återuppringning",
                "confirmRequestCallback": "Bekräftar anslutning via <channel> <phone> med en my IT support-agent på tyska"
            },
            "state": {
                "whatsTheIssue": "Vad är problemet du vill lösa?",
                "lastConversation": "Absolut, är problemet en del av den senaste konversationen?",
                "createIncidentLabel": "Du är på väg att skapa ett ärende för en incident",
                "cancelAck": "Noterat. Kan jag hjälpa dig med något annat problem?",
                "chatWithServiceDeskLabel": "Du är på väg att ansluta till en my IT support-agent",
                "createTicketLabel": "Bekräfta och skapa ärende",
                "cancelTicketLabel": "Avbryt ärendeskapande",
                "creatingIncidentTicket": "Skapar incidentärende",
                "ticketAttachment": "Vänligen bifoga en skärmdump av felet eller problemet.",
                "ticketAttachmentTooltipInstruction": "Tryck på Windows-logotypen + Print Screen eller använd klippverktyget för att ta en bild.",
                "ticketAttachmentTooltipWarning": "Bildstorleken måste vara mindre än 5 MB.",
                "ticketAttachmentLabel": "Bifoga en skärmdump",
                "ticketAttachmentTitle": "Bifogad skärmdump för ärendet",
                "ticketAttachmentError": "Det gick inte att bifoga den valda filen. Kontrollera att filen är i JPG- eller PNG-format och mindre än 5 MB.",
                "ticketAttachmentErrorAction": "Försök igen",
                "ticketDescription": "Ärendebeskrivning",
                "ticketNonITWarning": "Supporten hittade inga nyckelord som identifierar ditt problem som ett IT-relaterat problem.",
                "ticketNonITWarningQuestion": "Vill du skapa ett ärende hos my IT support baserat på din konversation om",
                "ticketNonITWarningRecommendationLabel": "Rekommendation:",
                "ticketNonITWarningRecommendationText": "Om du har ett problem som inte är relaterat till programvara eller hårdvara kan du försöka formulera om din sökning eller ställa en följdfråga nedan.",
                "connectWithServiceDeskLabel": "Bekräfta att du vill chatta med my IT support",
                "requestCallbackLabel": "Begär återuppringning",
                "requestCallbackInQueuePhone": "Din begäran om återuppringning har skickats. Du kommer att bli kontaktad inom cirka 5 minuter via <strong><phone></strong>. Under tiden kan du fortsätta använda andra applikationer.",
                "requestCallbackInQueueTeams": "Din begäran om återuppringning har skickats. Du kommer att bli kontaktad inom cirka 5 minuter via <strong>Microsoft Teams</strong>. Under tiden kan du fortsätta använda andra applikationer.",
                "requestCallbackFailed": "Vi kunde inte genomföra din återuppringning på grund av ett tekniskt fel. Försök igen.",
                "requestCallbackPromptAnswer": "Du är på väg att begära en återuppringning från my IT support",
                "requestCallbackConfirmLabel": "Bekräfta för att begära en återuppringning"
            },
            "tooltips": {
                "createIncident": "Assisterar dig genom att lösa ett IT-problem och vid behov, skapa ett ärende hos Servicedesk",
                "chatWithServiceDesk": "Assisterar dig genom att lösa ett IT-problem och vid behov, via chatt kontakta Servicedesk",
                "requestCallback": "Begär återuppringning från my IT support"
            }
        },
        "relevantSearches": "Mest relevanta sökningar",
        "resolveIssue": "Feedbackinlämning möjliggör supportåtgärder",
        "resolveIssueAfterFeedback": "Jag är ledsen att jag inte kunde lösa ditt problem. Hur kan jag hjälpa dig att komma vidare?",
        "searchBack": "Tillbaka till föregående sida",
        "selfServiceContent": "AI-stött självbetjäningsstöd för snabb lösning av servicetillbud",
        "selfServiceTitle": "IT-support",
        "sendbtn": "Skicka",
        "cancelBtn": "Avbryt återuppringning",
        "showMore": "Visa mer",
        "showMoreTooltip": "Visa hela svaret",
        "showLess": "Visa mindre",
        "showLessTooltip": "Minimera svaret",
        "continueAssistance": "Fortsätt med assistans",
        "continueAssistanceTooltip": "Fortsätt med assistans för att ställa följdfrågor",
        "ticketDescription": "Biljettbeskrivning baserad på senaste diskussionen",
        "ticketErrorMsg": "Något gick fel. Försök igen senare.",
        "ticketSuccessMsg": "Din incident har skapats framgångsrikt, biljettnummer:",
        "tone": "Ton",
        "topicStartMessage": "vilket IT-problem kan jag hjälpa dig med idag?",
        "welcomeMessage": "Chattuppmaning",
        "wentWell": "Vad gick bra? (valfritt)",
        "wentWrong": "Vad gick inte bra?",
        "jiraIntegration": {
            "viewInJira": "View in Jira",
            "responseHeading": "Sammanfattning av din Jira-ärenden:",
            "responseSubheading": "Visar topp 15",
            "noResponse": "Det verkar inte som att det finns ett JIRA-ärende registrerat för din förfrågan.",
            "supportedQuestionMsg": "Hey, I am sorry. I didn't quite understand your question. Can you please rephrase it again. I am sharing some sample questions to assist you:"
        },
        "intune": {
            "selectDevice": "Välj en enhet",
            "changeBrowserHomePage": "Ändra webbläsarens startsida",
            "fixWillBeApplied": "Åtgärden kommer att tillämpas på det här systemet",
            "confirm": "Bekräfta",
            "fixThis": "Åtgärda",
            "enterDeviceName": "Ange enhetsnamn",
            "selectOrEnterDevice": "Välj en enhet eller ange enhetsnamn.",
            "actionFailed": "Åtgärden misslyckades.",
            "working": "Arbetar...",
            "fixOnThis": "Tillämpa på denna enhet",
            "deviceLabel": "Enhet",
            "lastActive": "Senast aktiv",
            "today": "Idag",
            "yesterday": "Igår",
            "daysAgo": "dagar sedan",
            "deviceTypeLaptop": "Bärbar dator",
            "deviceTypeDesktop": "Stationär dator",
            "deviceTypeVirtualMachine": "Virtuell maskin",
            "deviceTypeUnknown": "Enhet",
            "homepageBrowserChange": {
                "syncInstructions": "Ändringen kommer nu att tillämpas på din enhet. Detta kan ta cirka 90 minuter. Om du vill påskynda processen kan du starta en manuell synkronisering från Company Portal:\n1. Öppna Company Portal\n2. Klicka längst ned till vänster på Settings bredvid kugghjulssymbolen.\n3. Klicka sedan på den blå knappen \"Synchronize\" och vänta tills synkroniseringen är klar.",
                "changeHomepageInstructions": "1. Klicka på de tre prickarna (...) längst upp till höger.\n2. Välj ”Inställningar”.\n3. Välj ”Start, startsida och nya flikar” i menyn till vänster.\n4. Under ”Vid start” ska du kontrollera att ”Öppna anpassade webbplatser” är valt/markerat.\n5. Klicka sedan på ”Lägg till webbplats”.\n6. Ange webbplatsadressen som du vill ställa in som din nya startsida i Microsoft Edge (till exempel: https://compass.eon.com/).\n7. Klicka på ”Lägg till”.\n\nOm du vill ta bort en webbplats från Startsida-listan klickar du på de tre prickarna (...) bredvid webbplatsen och sedan på ”Ta bort”.",
                "policyDescription": "Din organisation hanterar för närvarande webbläsarens startsideinställningar via enhetspolicyer. För att aktivera ändring av startsidan måste vi först identifiera vilken enhet som ska ta emot policyuppdateringen.",
                "deviceSelectedForPolicy": "vald för upplåsning av startsidepolicy",
                "stepsForEdge": "Steg för att ändra startsidan i Microsoft Edge",
                "whatsNextTitle": "Vad händer härnäst?",
                "whatsNextSubmitted": "En begäran om att tillåta en anpassningsbar startsida har skickats till din enhets policykö. ",
                "whatsNextSyncTime": "<strong>90 minuter</strong> genomsnittlig synkroniseringstid som behövs för uppdatering av bakgrundspolicyn. ",
                "whatsNextReturn": "Vänligen återgå till dina webbläsarinställningar efter 90 minuter och utför stegen nedan. ",
                "homepageEnabled": "Du kan nu ändra inställningarna för din webbläsares startsida. Observera att ändringen kanske inte träder i kraft omedelbart. Vänta cirka 30 minuter tills synkroniseringen är klar och stäng sedan och öppna Edge igen.",
                "homepageAlreadyEnabled": "Din enhet har redan aktiverat ändring av startsidan. Gå till webbläsarens inställningar och försök igen.",
                "homepageEnableFailed": "Jag kunde inte aktivera ändring av startsidan just nu. Försök igen senare.",
                "homepageRemoved": "Enheten har tagits bort från policyn för startsidan."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Oops! Something went wrong. Please try again later. If the issue persists please raise an issue from Quick Actions",
            "assistanceTask": "Assistance Task",
            "myActions": "Mina åtgärder",
            "itReportTitle": "Här är ögonblicksbilden av ditt systems energieffektivitet",
            "days": "Dagar",
            "device": "Enhet",
            "sinceRestarted": "sedan omstart",
            "deviceRestartRecommendation": "Omedelbar omstart av enheten rekommenderas",
            "deviceInCompliance": "Din enhet uppfyller kraven",
            "energyConsumed": "Energi som förbrukats under de senaste 7 dagarna",
            "coEmitted": "Co2 utsläpp under de senaste 7 dagarna",
            "cacheActionMsg": "Starta om webbläsaren för att ändringarna ska träda i kraft.",
            "diskClean": {
                "primaryBtn": "Ja, rensa min disk på temporära filer",
                "secondaryBtn": "Rensa inte min disk nu",
                "successMsg": "Din disk har rensats på temporära filer",
                "successMsgOnList": "Din disk har rensats på temporära filer.",
                "failureMsg": "Your disk could not be cleaned up at this point",
                "progressMsg": "Rensning av temporära filer pågår",
                "disclaimer": "Endast temporära systemfiler tas bort. Medan arbetet pågår kan du jobba på som vanligt.",
                "acknowledgeQuery": "Jag kan utföra en diskrensning åt dig. Under diskrensningen rensas onödiga filer, cachar eller gamla loggar på ditt system. Klicka på knappen nedan för att fortsätta."
            },
            "chromeCache": {
                "primaryBtn": "Ja, rensa Chrome-cache nu",
                "secondaryBtn": "Rensa inte min Chrome-cache nu",
                "successMsg": "Din Chrome-cache har rensats. Starta om webbläsaren för att ändringarna ska träda i kraft.",
                "successMsgOnList": "Din Chrome-cache har rensats.",
                "failureMsg": "Your Chrome Cache could not be cleaned up at this point",
                "progressMsg": "Rensning av Chrome-cache pågår",
                "disclaimer": "Endast temporära systemfiler tas bort. Medan arbetet pågår kan du jobba på som vanligt.",
                "acknowledgeQuery": "Jag kan hjälpa dig att rensa webbläsarcachen. Klicka på knappen nedan för att fortsätta."
            },
            "edgeCache": {
                "primaryBtn": "Ja, rensa Edge-cache nu",
                "secondaryBtn": "Rensa inte min Edge-cache nu",
                "successMsg": "Din Edge-cache har rensats. Starta om webbläsaren för att ändringarna ska träda i kraft.",
                "successMsgOnList": "Din Edge-cache har rensats.",
                "failureMsg": "Your edge Cache could not be cleaned up at this point",
                "progressMsg": "Rensning av Edge-cache pågår",
                "disclaimer": "Endast temporära systemfiler tas bort. Medan arbetet pågår kan du jobba på som vanligt.",
                "acknowledgeQuery": "Jag kan hjälpa dig att rensa webbläsarcachen. Klicka på knappen nedan för att fortsätta."
            },
            "empowerApp": {
                "primaryBtn": "Ja, vänligen reparera nu",
                "secondaryBtn": "Nej, Reparera inte nu",
                "successMsg": "Din Empower plugin-app har reparerats.",
                "successMsgOnList": "Din Empower plugin-app har reparerats.",
                "failureMsg": "Your Empower Plugin could not be repaired at this point",
                "progressMsg": "Automatisk reparation pågår",
                "disclaimer": "Vi kommer att installera om Empower Plugin, Vänligen stäng alla dina O365 appar innan du fortsätter.",
                "acknowledgeQuery": "Jag kan hjälpa dig med problem relaterade till Empower-tillägget. Klicka på knappen nedan för att reparera Empower-tillägget."
            },
            "teamsCache": {
                "primaryBtn": "Ja, rensa Teams cache nu",
                "secondaryBtn": "Rensa inte Teams-cacheminnet nu",
                "successMsg": "Ditt Teams-cache har rensats. Du kan öppna Teams och konfigurera om eventuella inställningar som kan ha återställts.",
                "successMsgOnList": "Din Teams-cache har rensats",
                "failureMsg": "Det gick inte att rensa din Teams Cache just nu",
                "progressMsg": "Rensa Teams-cache pågår",
                "disclaimer": "Observera att vi inte kommer att röra dina personliga eller arbetsrelaterade uppgifter. Medan städningen sker i bakgrunden kan du gärna använda hjälp.",
                "acknowledgeQuery": "Jag kan hjälpa dig att rensa Teams-cachen. Klicka på knappen nedan för att fortsätta."
            },
            "teamsReinstall": {
                "primaryBtn": "Ja, installera om Teams",
                "secondaryBtn": "Installera inte om Teams",
                "successMsg": "Appen Teams har installerats om",
                "successMsgOnList": "Appen Teams har installerats om",
                "failureMsg": "Ominstallation av Teams kunde inte slutföras",
                "progressMsg": "Ominstallation av Teams pågår",
                "disclaimer": "Observera att detta samtidigt kommer att ladda ner och installera om Teams-appen. Detta kommer att starta om Teams-appen, vänligen spara ditt arbete innan du fortsätter.",
                "acknowledgeQuery": "Att installera om appen Microsoft Teams kan lösa problemet. Klicka på knappen nedan för att fortsätta."
            },
            "outlookOst": {
                "primaryBtn": "Ja, Reparera Outlook",
                "secondaryBtn": "Reparera inte Outlook",
                "successMsg": "Outlook-profil återställd",
                "successMsgOnList": "Outlook-profil återställd",
                "failureMsg": "Outlook-profilen kunde inte återskapas",
                "progressMsg": "Återskapa Outlook-profil",
                "disclaimer": "Om du utför den här åtgärden kommer din Outlook-profil att återskapas lokalt, detta kommer att initiera nedladdning av e-postmeddelanden från Office Exchage, se till att det finns tillräckligt med nätverksbandbredd och lagring.",
                "acknowledgeQuery": "Detta kan bero på anslutningsproblem eller föråldrade inställningar. Jag kan hjälpa dig att felsöka och få Outlook i synk igen."
            },
            "repairOfficeApps": {
                "primaryBtn": "Ja, reparera Office-appar",
                "secondaryBtn": "Reparera inte Office-appar",
                "successMsg": "Office-appar reparerade",
                "successMsgOnList": "Office-appar reparerade",
                "failureMsg": "Det gick inte att reparera Office-program",
                "progressMsg": "Office-appar installeras om",
                "disclaimer": "Om du utför den här åtgärden kommer du samtidigt att installera om Office-appar och försöka reparera dem, spara allt osparat arbete innan du fortsätter.",
                "acknowledgeQuery": "Detta kan bero på en skadad installation eller kompatibilitetsproblem. Jag kan hjälpa dig att reparera Office-appar så att de öppnas smidigt."
            },
            "intuneSync": {
                "primaryBtn": "Ja, initiera Intune-synkronisering",
                "secondaryBtn": "Starta inte synkronisering",
                "successMsg": "Intune-synkroniseringen har slutförts",
                "successMsgOnList": "Intune-synkroniseringen har slutförts",
                "failureMsg": "Intune-synkronisering kunde inte inledas",
                "progressMsg": "Intune Sync pågår",
                "disclaimer": "Observera att den här åtgärden endast startar om Intune Sync-tjänster, detta installerar eller reparerar inte Intune (Företagsportal).",
                "acknowledgeQuery": "Jag kan hjälpa dig att uppdatera enhetens status och synkronisera den med Intune för att säkerställa att den uppfyller kraven, är uppdaterad och tillämpar de senaste principerna."
            },
            "teamsAddin": {
                "primaryBtn": "Ja, aktivera MS Teams-tillägget",
                "secondaryBtn": "Aktivera inte tillägget",
                "successMsg": "Reparation av MS Teams-tillägget är slutförd",
                "successMsgOnList": "Reparation av MS Teams-tillägget är slutförd",
                "failureMsg": "MS Teams-tillägget kunde inte aktiveras",
                "progressMsg": "MS Teams-tillägget aktiveras",
                "disclaimer": "Observera att reparation av MS Teams-tillägget kräver att Outlook startas om. Spara allt arbete innan du fortsätter.",
                "acknowledgeQuery": "Jag kan hjälpa till att återställa Teams-tillägget i Outlook så att du kan schemalägga möten igen. Klicka på knappen nedan för att fortsätta."
            },
            "windowsUpdate": {
                "primaryBtn": "Ja, sök efter uppdateringar",
                "secondaryBtn": "Nej, sök inte",
                "successMsg": "Windows Update har startats",
                "successMsgOnList": "Windows Update har startats",
                "failureMsg": "Det gick inte att starta Windows Update",
                "progressMsg": "Söker efter uppdateringar",
                "disclaimer": "Denna åtgärd är avsedd att söka och ladda ner uppdateringar från Microsoft. Se till att du är ansluten till ett lämpligt nätverk för att ladda ner uppdateringar.",
                "acknowledgeQuery": "Jag kan hjälpa till att lösa problem med Windows Update och efterlevnad på din enhet. Klicka på knappen nedan för att fortsätta"
            },
            "smartSolution": {
                "systemName": "Systemnamn",
                "primaryBtn": "Utför hälsokontroll",
                "secondaryBtn": "Inte nu",
                "askToRunHealthCheck": "Vill du ha hjälp med att göra en snabb hälsokontroll?",
                "healthCheckApiRunning": "Analysera och utföra hälsokontroller på",
                "healthCheckApiFail": "Det gick inte att hämta hälsokontrollinformation, försök igen",
                "healthCheckApiSuccess": "Jag har analyserat systemet. Följande problem kvarstår:",
                "systemCheckMsg": "Systemkontroll pågår",
                "systemCheckMessages": {
                    "recentlyStarted": "Systemet är uppdaterat och nyligen startat om",
                    "appsHealthy": "Alla appinstallationer är i gott skick",
                    "driveSpace": "Det finns gott om ledigt utrymme på systemdisken",
                    "noCrashes": "Inga programkrascher har upptäckts nyligen"
                },
                "healthCheckNoIssue": "Jag har analyserat systemet. <b>Allt verkar fungera som det ska.</b>",
                "recommendedActionHeading": "Rekommenderade åtgärder",
                "askForElaboration": "Du kan också förklara det specifika problemet eller ladda upp en skärmdump av problemet du upplever.",
                "remindForSystemCheck": "Okej, du kan meddela mig när du vill göra en systemkontroll.",
                "recommendedFixesHeading": "Rekommenderade lösningar",
                "recommendedActionInfo": "Markera eller avmarkera de föreslagna korrigeringarna om det behövs",
                "noRecommendedAction": "Inga rekommenderade åtgärder är tillgängliga",
                "initiateActionsButton": "Börja fixa",
                "selectedActionsProgress": "Valda åtgärder bearbetas.",
                "selectedActionsProgressNote": "Känn dig fri att använda assistansen medan åtgärden utförs. Ditt åtgärdsalternativ har lagts till i listan över assistansuppgifter och du kan kontrollera förloppet, du kommer att meddelas när åtgärden har slutförts.",
                "selectedActionsCompleted": "Valda åtgärder har slutförts.",
                "selectedActionsFailed": "Valda åtgärder misslyckades. Mer information finns på kortet Assistansuppgift.",
                "selectedActionsPartiallyCompleted": "Valda åtgärder är delvis slutförda. Mer information finns på kortet Hjälpuppgift.",
                "myActionDone": "Markera som klart",
                "manualActionDisclaimer": "Denna process innehåller både automatiserade och manuella steg. Vänligen slutför åtgärderna när du blir ombedd",
                "manualActionNotification": "För att slutföra åtgärden, utför de ytterligare stegen manuellt som anges under Mina åtgärder.",
                "deviceSelectionHeading": "Jag ser att du använder flera system. Om du vill utföra följande åtgärd i ett annat system, välj från listan nedan.",
                "deviceSelectionLabel": "Välj system för Nexthink-åtgärd",
                "alerts": {
                    "successTitle": "Uppgiften är klar!",
                    "successMessage": "Valda åtgärder har slutförts framgångsrikt.",
                    "errorTitle": "Uppgiften misslyckades!",
                    "errorMessage": "Det uppstod ett fel när den valda åtgärden skulle bearbetas.",
                    "partialTitle": "Uppgiften slutförd delvis!",
                    "partialMessage": "Valda åtgärder är delvis slutförda. Mer information finns på kortet Hjälpuppgift."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Det har förekommit <n> blåskärmar på din enhet under de senaste 7 dagarna.",
                        "action": "Kontakta GSD för ytterligare hjälp",
                        "actionInfo": "Kontakta GSD för ytterligare hjälp"
                    },
                    "edgeCrashes": {
                        "message": "Vi har hittat bevis för <n> krascher relaterade till Edge-webbläsaren under de senaste 7 dagarna. Vi kommer att försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Rensa Edge-webbläsarens cache",
                        "actionInfo": "Detta rensar Edge-webbläsarens cache, inga personliga filer ändras"
                    },
                    "chromeCrashes": {
                        "message": "Vi har hittat bevis för <n> krascher relaterade till Chrome-webbläsaren under de senaste 7 dagarna. Vi kommer att försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Rensa Chrome-webbläsarens cache",
                        "actionInfo": "Detta rensar Chrome-cachen, inga befintliga filer ändras."
                    },
                    "zScalarStatus": {
                        "message": "Vi har upptäckt att Zscaler-tjänsten har stött på några problem på din enhet. Vi kan försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Starta om Zscaler-tjänsten",
                        "actionInfo": "Denna åtgärd startar om nätverksanslutningen. Den påverkar inte dina öppna program."
                    },
                    "zScalarState": {
                        "message": "Vi har upptäckt att Zscaler-tjänsten har stött på några problem på din enhet. Vi kan försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Återställ Zscaler",
                        "actionInfo": "Denna åtgärd startar om nätverksanslutningen. Den påverkar inte dina öppna program."
                    },
                    "driveFreeSpace": {
                        "message": "Din enhet har endast <n> GB ledigt utrymme kvar. För att säkerställa att datorn fungerar optimalt rekommenderar vi att du ökar mängden ledigt utrymme som Windows kan använda, genom att köra ett skript på din dator.",
                        "action": "Utför diskrensning",
                        "actionInfo": "Endast temporära filer och papperskorgen på din enhet rensas vid denna åtgärd."
                    },
                    "daysSinceFullBoot": {
                        "message": "Din enhet har inte startats om helt under de senaste <n> dagarna. Detta skiljer sig från en vanlig avstängning. Vi rekommenderar att du gör en fullständig omstart av datorn (Start | Avstängning | Starta om).",
                        "action": "Starta om enheten så snart som möjligt.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Vi har hittat bevis för <n> krascher relaterade till Microsoft Teams under de senaste 7 dagarna. Vi kan försöka åtgärda detta genom att köra ett skript som rensar din Microsoft Teams-cache.",
                        "action": "Kör Teams-cache-rensning",
                        "actionInfo": "Denna åtgärd rensar MS Teams-cache och startar om programmet. Detta kan även ta bort utkast/oskickade Teams-meddelanden."
                    },
                    "teamsPluginDisabled": {
                        "message": "Vi har upptäckt att Microsoft Teams-tillägget i Microsoft Outlook är inaktiverat. Detta orsakar problem mellan de två applikationerna. Vi kan försöka åtgärda detta genom att köra ett skript som konfigurerar om inställningarna.",
                        "action": "Aktivera Outlook-tillägg",
                        "actionInfo": "Denna åtgärd aktiverar Teams-tillägget i Outlook och startar om programmet."
                    },
                    "outlookOstStatus": {
                        "message": "Din Outlook-profil har överskridit sin rekommenderade storlek, vilket kan leda till problem med din e-posthantering. Vi kan åtgärda detta genom att köra ett skript som återskapar profilfilen.",
                        "action": "Reparera Outlook OST-fil",
                        "actionInfo": "Detta byter namn på din Outlook OST-fil och startar om programmet. Eventuella utkast till e-post tas bort."
                    },
                    "lastOsUpdate": {
                        "message": "Vi ser att Windows Update-tjänsten inte fungerar som förväntat, och din dator uppdaterades senast för <n> dagar sedan. Vi rekommenderar att du gör en fullständig omstart av datorn (Start | Avstängning | Starta om), vilket hjälper till att återställa vissa inställningar.",
                        "action": "Starta om enheten så snart som möjligt",
                        "actionInfo": ""
                    },
                    "ZScalarStatus": {
                        "message": "Vi har upptäckt att Zscaler-tjänsten på din enhet har haft några problem. Vi kan försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Starta om Zscaler-tjänsten",
                        "actionInfo": "Denna åtgärd kommer att starta om din nätverksanslutning. Det kommer inte att påverka dina redan öppnade program."
                    },
                    "ZScalarState": {
                        "message": "Vi har upptäckt att Zscaler-tjänsten på din enhet har haft några problem. Vi kan försöka åtgärda detta genom att köra ett skript på din dator.",
                        "action": "Återställ Zscaler",
                        "actionInfo": "Denna åtgärd kommer att starta om din nätverksanslutning. Det kommer inte att påverka dina redan öppnade program."
                    }
                },
                "acknowledgeQuery": "Jag kan hjälpa dig att felsöka problemet med din enhet. Låt oss kontrollera och lösa problemet"
            },
            "declineScriptMsg": "Jag vill inte köra Nexthink-skriptet, hjälp mig med en annan lösning",
            "timezone": {
                "primaryBtn": "Ja, fortsätt vidare",
                "secondaryBtn": "Nej, uppdatera inte",
                "successMsg": "Tidszonsdetektering har ställts in på automatisk",
                "successMsgOnList": "Tidszonsdetektering har ställts in på automatisk",
                "failureMsg": "Tidszonskonfigurationen kunde inte uppdateras",
                "progressMsg": "Uppdaterar tidszonsinställningarna",
                "disclaimer": "Observera att denna åtgärd är utformad för att ställa in tidszonstjänsten på automatisk, vilket tillåter Windows att uppdatera skrivbordsklockan baserat på detekterad plats.",
                "acknowledgeQuery": "Jag kan hjälpa dig att åtgärda inställningarna för systemtid och tidszon. De flesta tidsrelaterade problem, som klockdrift, felaktiga tidsstämplar, misslyckade autentiseringskoder eller felaktiga mötestider, orsakas av felaktig tidszon eller inaktiverad autosynkronisering. Klicka på knappen nedan för att automatiskt upptäcka och åtgärda din Windows-konfiguration för tid och tidszon."
            },
            "chooseBrowser": "Välj webbläsare för åtgärd för rensning av cache",
            "outlookAutoComplete": {
                "primaryBtn": "Ja, rensa Outlook-cache",
                "secondaryBtn": "Nej, rensa inte Outlook-cache",
                "successMsg": "Outlook-autokompletteringscache har rensats",
                "successMsgOnList": "Outlook-autokompletteringscache har rensats",
                "failureMsg": "Outlook-autokompletteringscache kunde inte rensas",
                "progressMsg": "Rensar Outlook-autokompletteringscache",
                "disclaimer": "Observera att rensning av Outlooks autokompletteringscache tar bort sparade förslag på e-postadresser. Denna åtgärd kan inte ångras.",
                "acknowledgeQuery": "Jag kan hjälpa dig att åtgärda Outlooks cache för automatisk komplettering. Klicka på knappen nedan för att automatiskt åtgärda Outlooks automatiska komplettering."
            },
            "restartZscalar": {
                "primaryBtn": "Ja, fortsätt",
                "secondaryBtn": "Nej, starta inte om Zscaler",
                "successMsg": "Zscaler har startats om",
                "successMsgOnList": "Zscaler har startats om",
                "failureMsg": "Zscaler kunde inte startas om",
                "progressMsg": "Startar om Zscaler-tjänster",
                "disclaimer": "Observera att omstart av Zscaler tillfälligt kan koppla bort din internetanslutning och arbetsapplikationer. Detta tar vanligtvis mindre än en minut.",
                "acknowledgeQuery": "Jag kan hjälpa dig att åtgärda problem med Zscaler-tjänsterna. Klicka på knappen nedan för att åtgärda dina Zscaler-problem."
            },
            "onedrive": {
                "primaryBtn": "Ja, reparera OneDrive",
                "secondaryBtn": "Nej, utför inte OneDrive-reparationen",
                "successMsg": "OneDrive-reparationen har slutförts",
                "successMsgOnList": "OneDrive-reparationen har slutförts",
                "failureMsg": "Åtgärden för OneDrive-reparation kunde inte slutföras framgångsrikt",
                "progressMsg": "Utför OneDrive-reparation",
                "disclaimer": "Observera att en reparation av OneDrive gör att lokala filer synkroniseras till molnet och kan störa anpassade synkroniseringar för OneDrive",
                "acknowledgeQuery": "Jag kan hjälpa dig att åtgärda dina OneDrive-problem. Klicka på knappen nedan för att åtgärda dina OneDrive-problem."
            },
            "smartcard": {
                "primaryBtn": "Ja, ta bort Smartcard",
                "secondaryBtn": "Nej, ta inte bort Smartcard",
                "successMsg": "Microsoft Smartcard har tagits bort",
                "successMsgOnList": "Microsoft Smartcard har tagits bort",
                "failureMsg": "Det gick inte att ta bort Microsoft Smartcard",
                "progressMsg": "Tar bort Microsoft Smartcard",
                "disclaimer": "Att utföra den här åtgärden kan ta upp till 1 minut.",
                "acknowledgeQuery": "Jag kan hjälpa dig att åtgärda problem med Microsoft Smart Card Reader. Klicka på knappen nedan för att åtgärda dina Smart Card-problem."
            },
            "errorFetchingReport": "Tyvärr kunde jag inte hämta rapporten. Vänligen försök igen senare.",
            "automatedFix": "Automatisk åtgärd",
            "automatedFixConsent": "Jag kan åtgärda det här problemet på din enhet. Vill du att jag initierar den automatiska åtgärden?",
            "primaryButton": "Ja, initiera åtgärden",
            "teamViewerReset": {
                "primaryBtn": "Ja, gå vidare",
                "secondaryBtn": "Nej, återställ inte",
                "successMsg": "Teamviewer-tjänsterna har återställts",
                "successMsgOnList": "Teamviewer-tjänsterna har återställts",
                "failureMsg": "Det gick inte att återställa Teamviewer-tjänsterna",
                "progressMsg": "Teamviewer-tjänsterna startas om",
                "disclaimer": "Den här åtgärden återställer dina teamviewer-tjänster och startar om din teamviewer-app. Se till att ditt arbete är sparat innan du fortsätter",
                "acknowledgeQuery": "Jag kan hjälpa till att återställa Teamviewer. Klicka på knappen nedan för att fortsätta."
            },
            "zoomUninstall": {
                "primaryBtn": "Ja, avinstallera Zoom",
                "secondaryBtn": "Nej, avinstallera inte",
                "successMsg": "Zoom har avinstallerats",
                "successMsgOnList": "Zoom har avinstallerats",
                "failureMsg": "Det gick inte att ta bort Zoom",
                "progressMsg": "Avinstallation av Zoom pågår",
                "disclaimer": "Denna åtgärd avinstallerar Zoom från din enhet och rensar även alla konfigurationer för Zoom.",
                "acknowledgeQuery": "Jag kan hjälpa dig att avinstallera Zoom. Klicka på knappen nedan för att fortsätta."
            },
            "webexUninstall": {
                "primaryBtn": "Ja, avinstallera Webex",
                "secondaryBtn": "Nej, avinstallera inte",
                "successMsg": "Webex har avinstallerats",
                "successMsgOnList": "Webex har avinstallerats",
                "failureMsg": "Det gick inte att ta bort Webex",
                "progressMsg": "Avinstallation av Webex pågår",
                "disclaimer": "Denna åtgärd avinstallerar Cisco Webex från din enhet och rensar även alla konfigurationer för Cisco Webex.",
                "acknowledgeQuery": "Jag kan hjälpa dig att avinstallera Cisco Webex. Klicka på knappen nedan för att fortsätta."
            },
            "recommendedAction": "Rekommenderad åtgärd",
            "noKbArticleFound": "Inga manuella steg eller kunskapsartiklar hittades för detta problem. Det finns dock en rekommenderad åtgärd som kan lösa det:"
        },
        "sessions": {
            "title": "Senaste chattarna",
            "clearAll": "Rensa allt",
            "deleteMessage": "Ta bort session",
            "footer": "Obs: Konversationer från de senaste 30 dagarna kommer att sparas.",
            "noRecentChat": "Inga senaste chattar",
            "startNewChat": "Starta ny chatt",
            "learnMore": "Läs mer.",
            "learnMoreTooltip": "Enligt MyHelp-bevarande policyn kommer dina senaste chattar att vara tillgängliga i 30 dagar om du inte raderar de senaste chattarna med hjälp av radera eller rensa alla knappar."
        },
        "incError": "Vänligen ange giltiga incidentdetaljer",
        "contactError": "Vänligen ange giltigt telefonnummer",
        "searchAsk": "Beskriv ditt problem, t.ex. lösenordsåterställning...",
        "teamsInsights": {
            "specifyDateTime": "Kan du ange datum och tid för när detta inträffade samt vilket specifikt möte eller vilken chatt som berördes?",
            "date": "Datum",
            "getMeetings": "Hämta möten",
            "cancel": "Avbryt",
            "noMeetings": "Inga möten hittades för valt datum.",
            "meetingInstruction": "Välj det specifika möte som påverkades av kvalitetsproblemen.",
            "identifyIssue": "Identifiera problemet",
            "issueDetectionCompleted": "Problemdetektering slutförd.",
            "detectingIssues": "Identifierar problem med mötet",
            "recommendedActions": "Rekommenderade åtgärder:",
            "noInsightsFound": "Inga insikter hittades för det valda samtalet.",
            "meetingList": "Möteslista",
            "fetchingMeetings": "Hämtar alla Teams-möten för dagen",
            "windowsOnly": "Mötesinsikter är endast tillgängliga för samtal som anslutits via Windows-enheter.",
            "confirmCreateIncident": "Vill du skapa en incidentbiljett för problemet som upptäcktes i mötet?",
            "getMeetingsCancelMsg": "Begäran om att hämta möten har avbrutits.",
            "identifyIssueCancelMsg": "Begäran om att identifiera problem har avbrutits.",
            "createIncidentCancelMsg": "Begäran om att skapa en incident har avbrutits.",
            "report": {
                "lowWifiRootCause": "Din WiFi-signal var svag under samtalet, vilket kan ha orsakat kvalitetsproblem. Kontrollera avståndet till din router om du var ansluten från ett hem-/fjärrnätverk.",
                "networkIssueRootCauseManaged": "Det verkar som att du var uppkopplad från ett E.ON-kontor och har upplevt nätverksproblem som påverkat mötets kvalitet. Överväg att öppna en incidentbiljett för att rapportera detta och ange platsen du befann dig på i biljetten.",
                "networkIssueRootCauseUnmanaged": "Det verkar som att du inte var uppkopplad från ett E.ON-kontor och kan ha upplevt nätverksproblem som påverkat mötets kvalitet. Kontrollera stabiliteten på din lokala WiFi- eller internetanslutning. Använd om möjligt en kabelanslutning eller flytta närmare din WiFi-router för att förbättra nätverksprestandan.",
                "noDataRootCause": "Inga insikter var tillgängliga för den här parametern under samtalet.",
                "noIssueRootCause": "Inget problem upptäcktes för den här parametern.",
                "noIssueRecommendation": "Ingen åtgärd krävs.",
                "failed": "Misslyckades",
                "checking": "Kontrollerar",
                "okay": "Okej",
                "na": "N/A",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Enhetens CPU-användning",
                    "rootCause": "Vi har upptäckt hög CPU-belastning på din enhet under samtalet. Kontrollera om du hade bakgrundsprocesser eller appar öppna och igång under samtalet, och undvik att ha för många appar öppna samtidigt så att enhetens hårdvaruprestanda kan avsättas till mötet.",
                    "recommendation": "Stäng onödiga bakgrundsprogram under samtal för att minska CPU-belastningen."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Enhetens minnesanvändning",
                    "rootCause": "Vi har upptäckt hög minnesanvändning på din enhet under samtalet. Kontrollera om du hade bakgrundsprocesser eller appar öppna och igång under samtalet, och undvik att ha för många appar öppna samtidigt så att enhetens hårdvaruprestanda kan avsättas till mötet.",
                    "recommendation": "Stäng onödiga bakgrundsprogram under samtal för att minska minnesanvändningen."
                },
                "wifiSignalQuality": {
                    "displayName": "WiFi-signalens kvalitet",
                    "recommendation": "Gå närmare din router eller byt till en starkare WiFi-signalkälla."
                },
                "audioJitter": {
                    "displayName": "Ljudjitter"
                },
                "audioJBDelay": {
                    "displayName": "Fördröjning i ljudjitterbuffer"
                },
                "audioRecvLossRate": {
                    "displayName": "Förlustgrad för mottaget ljud"
                },
                "audioRtt": {
                    "displayName": "Ljudets rundturstid"
                },
                "videoRtt": {
                    "displayName": "Videons rundturstid"
                },
                "videoRecvLossRate": {
                    "displayName": "Förlustgrad för mottagen video"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "WiFi-kanalens mittfrekvens (kHz)",
                    "rootCause": "Du använder en WiFi-anslutning på 2,4 GHz, vilket ofta orsakar problem med samtalskvaliteten. Överväg att byta till ett WiFi-band på 5 GHz eller högre.",
                    "recommendation": "Byt till ett WiFi-band på 5 GHz (eller högre) för att förbättra samtalskvaliteten."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Nätverksbyte upptäckt",
                    "rootCauseManaged": "Vi har identifierat WiFi- eller åtkomstpunktsändringar under ditt samtal på ett E.ON-kontor. Detta kan ha orsakat ett avbrott i samtalet. Om du inte flyttade dig med din enhet, vänligen registrera detta som en incidentbiljett.",
                    "rootCauseUnmanaged": "Vi identifierade att du inte var ansluten från en E.ON-plats. Kontrollera att din WiFi-anslutning är stabil, eftersom nätverksproblem kan påverka mötets kvalitet."
                }
            }
        }
    },
    "close": "Stäng",
    "confirm": "Bekräfta",
    "reset": "Återställ",
    "continue_Tour": "Fortsätt rundturen",
    "dataTable": {
        "itemString": "föremål",
        "ofString": "av",
        "pagingData": "Objekt per sida"
    },
    "delete": "Radera",
    "edit": "Redigera",
    "feedbackWidget": "Återkoppling",
    "filterPage": {
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "ItOrder": "min IT-beställning",
            "JIRA": "Jira",
            "Knowledge Base": "Kunskapsbas",
            "MyGenius": "MyGenius",
            "Sharepoint": "SharePoint",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Annat"
        },
        "filterMenu": {
            "all": "Alla",
            "enterSearchTerm": "Skriv ditt sökord och förfina dina resultat",
            "disclaimer": "Vissa resultat kanske inte är helt relevanta. Var vänlig granska noggrant.",
            "app": "Appar",
            "gitlab": "Gitlab",
            "apps": "Appar",
            "backBtn": "Tillbaka till föregående sida",
            "card_languages": "Språk",
            "community": "Gemenskap",
            "datasources": "Datakällor",
            "ecl_source_name": "Källa",
            "filterHeading": "Filter",
            "jql": "jql",
            "people": "Personer",
            "emails": "Mina Emails",
            "teams": "Teams",
            "loading": "Laddar",
            "lookingFor": "Jag letar efter",
            "m365": "Mina filer",
            "mimeType": "Typ",
            "noData": "Vi kunde inte hitta några resultat för",
            "noMoreData": "Inga fler resultat hittades för din förfrågan!",
            "pages": "Sidor",
            "priority": "Prioritet",
            "refineResults": "Förfina resultaten",
            "reset": "Återställ filter",
            "space": "Utrymme",
            "standard_card_type": "Typ",
            "status": "Status",
            "timeRange": "Tidsintervall",
            "department": "Avdelning",
            "users": "Användare",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "My IT order",
            "aiAssistant": "Assistance",
            "compass": "Compass",
            "categoryTags": "Kategori",
            "kb_articles": "IT Support",
            "officeBuddy": "E.ON Knowledge base",
            "key": "Projekt",
            "companyTags": "Affärsenhet",
            "searchIn": "Sök i",
            "time": "Tid"
        },
        "searchResult": {
            "availableLanguages": "Tillgängliga språk",
            "category": "Kategori",
            "business": "företag",
            "mobile": "Mobil",
            "createdBy": "Skapad av",
            "createdOn": "Skapad den",
            "deliveryTime": "Leveranstid",
            "duration": "Varaktighet",
            "lastUpdate": "Senaste uppdatering",
            "lastUpdated": "Senaste uppdatering",
            "source": "Källa",
            "status": "Status",
            "type": "Typ",
            "company": "Företag",
            "department": "Avdelning",
            "job_title": "Befattning",
            "office_location": "Kontorsplats",
            "email": "Email",
            "preview": "Förhandsgranska",
            "viewEmail": "Visa e-post"
        },
        "timeRangeOptions": {
            "All": "Alla",
            "yesterday": "1 dag",
            "lastWeek": "7 dagar",
            "lastMonth": "1 månad",
            "6 Months": "6 månader",
            "lastYear": "1 år"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Alla affärsenheter"
        },
        "searchOptionsHover": "Visar innehåll från din affärsenhet, E.ON-gruppens innehåll eller innehåll från andra affärsenheter."
    },
    "footer": {
        "PKI": "PKI",
        "aboutMe8EON": "Om MyHelp",
        "contact": "Kontakta",
        "copyrights": "",
        "imprint": "Avtryck",
        "privacyPolicy": "Sekretesspolicy",
        "privacySettings": "Sekretessinställningar",
        "termsofUse": "Användarvillkor"
    },
    "headerData1": "MyHelp",
    "headerData2": "Din AI-assistent för IT-support",
    "headerMessage": "Använd <span class='me8eon'>MyHelp</span> för att åtgärda IT-problem, följa steg-för-steg-guider eller bli hänvisad till rätt IT-supportkanal.",
    "landingPage": {
        "hello": "Hej",
        "searchApps": "Appar",
        "suggestions": "Förslag",
        "title": "Hur kan jag hjälpa dig?"
    },
    "logIn": "Logga in",
    "logOff": "Logga ut",
    "loginLable": "Logga in",
    "moveTabAndTiles": {
        "actionUndone": "Denna åtgärd kan inte ångras.",
        "addTab": "Lägg till ny flik",
        "addTabButton": "Lägg till flik",
        "addTabTitle": "Lägg till en ny flik. Du kan skapa maximalt 4 flikar.",
        "cardIn": "brickor i?",
        "categorizeTiles": "Personlig instrumentpanel",
        "categorizeTilesTitle": "Byt namn på flikar, ta bort flikar och flytta brickor inom flikar",
        "enterTabName": "Ange fliknamn",
        "favourite": "Favorit",
        "organiseTilesTitle": "För att ändra brickornas position",
        "personalizeTab": "Anpassa flikar",
        "personalizeTiles": "Anpassa brickor",
        "removeTabConfrim": "Är du säker på att du vill ta bort fliken",
        "tabInputLabel": "Fliknamn",
        "tabNameError": "Ange ett unikt fliknamn med minst 2 och högst 20 tecken!",
        "tabNames": "Flik",
        "with": "med"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Alla",
            "claim": "Krav",
            "leaveApptoval": "Ledighetsgodkännande",
            "serviceRequest": "Serviceförfrågan",
            "timeSheet": "Tidrapport"
        },
        "tableData": {
            "approve": "Godkänn",
            "description": "Beskrivning",
            "reject": "Avvisa",
            "requestId": "Begärans-ID",
            "requestedBy": "Begärd av",
            "requestedDate": "Önskat datum",
            "requestedType": "Begärd typ",
            "status": "Status"
        }
    },
    "no": "Nej",
    "organiseTiles": "Ordna brickor",
    "registerLable": "Registrera",
    "save": "Spara",
    "searchPage": {
        "addAppTooltip": "Lägg till på instrumentpanelen",
        "addedAppTooltip": "Tillagd i instrumentpanelen",
        "relatedApps": "Relaterade appar",
        "removeAppTooltip": "Ta bort från instrumentpanelen",
        "searchApps": "Sök här...",
        "searchPlaceholder": "Sök...",
        "viewMoreApps": "Flera"
    },
    "pwaText": {
        "header": "Installera den här appen på din startskärm!",
        "button": "Installera appen",
        "iphoneHeader": "För att installera den här appen på iPhone",
        "inst1": "Knacka på <b>Dela</b>-knappen i Safari.",
        "inst2": "Bläddra ner och välj <b>\"Lägg till på startskärmen\".</b>",
        "inst3": "Knacka på <b>Lägg till</b> i det övre högra hörnet.."
    },
    "skip_Tour": "Hoppa över rundturen",
    "snow": {
        "tabName": {
            "incidents": "Incidenter",
            "incidentsTable": {
                "btnText": "Öppna ny incident",
                "noData": "Inga tillgängliga data",
                "ongoing": "Pågående",
                "closed": "Stängd",
                "headlineText": "Incidenter"
            },
            "itResources": "IT-resurser",
            "itResourcesTable": {
                "btnText": "Öppna en biljett för IT-resurser",
                "computerName": "Datornamn",
                "model": "Modell",
                "modelCategory": "Modellkategori",
                "noData": "Inga tillgängliga data",
                "serialNumber": "Serienummer",
                "serviceValue1": "Servicevärde1",
                "serviceValue2": "Servicevärde2",
                "headlineText": "Mina tillgångar"
            },
            "orderTable": {
                "approvalSet": "Godkännandeset",
                "btnText": "Beställ IT-tjänster",
                "catItem": "Kattobjekt",
                "createdOn": "Skapad den",
                "dueDate": "Förfallodatum",
                "noData": "Inga tillgängliga data",
                "number": "Nummer",
                "state": "Tillstånd",
                "headlineText": "Order",
                "tooltipText": "Begär och hantera IT-utrustning, programvara, licenser eller tjänster"
            },
            "orders": "Order"
        },
        "welcomeNote": "Nedan hittar du en översikt över dina öppna incidentbiljetter, dina förfrågningar och dina IT-resurser."
    },
    "submit": "Skicka in",
    "switchLanguage": "Byt språk",
    "switchRole": "Byt roll",
    "new": "Nytt",
    "whatsnew": "Se vad som är nytt",
    "whatsnewtt": "Ta reda på vad som är nytt på Myhelp",
    "tilePage": {
        "backToSearch": "Tillbaka till föregående sida",
        "myInboxCountSuffix": "I väntan"
    },
    "tourData": {
        "tab": {
            "step1": "Du kan lägga till en ny flik genom att klicka här.",
            "step2": "Klicka här för att organisera ordningen på brickorna.",
            "step3": "Här kan du byta namn på och organisera flikar."
        },
        "tile": {
            "step1": "Använd MyHelp för att hitta arbetsapplikationer, processer, information och resurser som är relevanta för din organisation (till exempel projektrelaterad information, utbildningar, företagsdokument, policyer och mycket mer).",
            "step2": "Lär dig mer om MyHelp och dess funktioner, hitta svar på vanliga frågor och ta del av användbara tips och tricks i användardokumentationen.",
            "step3": "Du kan när som helst ändra det föredragna språket här.",
            "step4": "Du kan logga ut genom att klicka här.",
            "step5": "Börja med en ny konversation, hämta dina senaste chattar för att fortsätta där du slutade eller starta en E.ON-sökning genom att trycka på förstoringsglaset",
            "step6": "Din personliga instrumentpanel låter dig organisera och komma åt dina favoritapplikationer. Sök efter en app och lägg till den med plustecknet. Skapa nya flikar och ordna om appar efter behov."
        },
        "userActions": {
            "back": "Tillbaka",
            "close": "Stäng",
            "last": "Avsluta",
            "next": "Nästa",
            "step": "steg",
            "of": "av",
            "open": "Öppna dialogrutan",
            "skip": "Hoppa över",
            "start_tour": "Starta rundturen",
            "tour_info": "Vill du att vi visar dig de grundläggande funktionerna i en snabb guidad tur? Det tar bara 1-2 minuter..."
        },
        "chat": {
            "step1": "Beskriv ditt IT-problem",
            "step1_description": "Få steg-för-steg-hjälp för vanliga IT-problem – baserat på E.ONs kunskapsdatabaser för IT-support. Vid behov leder MyHelp dig också vidare till rätt IT-supportkanal.",
            "step2": "Upptäck vanliga IT-ärenden",
            "step2_description": "Dessa exempel visar vanliga IT-ärenden där MyHelp kan hjälpa dig steg för steg.",
            "step3": "Få snabbare åtkomst till dina appar",
            "step3_description": "Använd instrumentpanelen för att spara ofta använda appar och skapa din personliga arbetsyta.",
            "step4": "Starta en ny chatt eller fortsätt tidigare chattar",
            "step4_description": "Använd sidopanelen för att starta en ny chatt eller snabbt gå tillbaka till tidigare chattar."
        }
    },
    "trash_bin": "Radera",
    "underDevelopmentMsg": "Denna sida är under utveckling",
    "userName": "Profilnamn",
    "yes": "Ja",
    "allApps": {
        "addAppsBtn": "Lägg till appar",
        "addAppsInfo": "Klicka på Lägg till appar för att komma igång",
        "addAppsTitle": "Skapa din personliga arbetsyta",
        "addAppsDesc": "Lägg till dina mest använda appar för snabbare åtkomst till de verktyg du använder varje dag",
        "customTileButton": "Lägg till anpassat kort",
        "CustomTileHeading": "Anpassat kort",
        "customTileTitleLabel": "Korttitel",
        "customTileSubTitle": "Kortbeskrivning",
        "customTileUrlLabel": "Kortlänk",
        "createCardBtn": "Skapa kort",
        "modalHeading": "Appar på E.ON",
        "modalDesc": "Sök eller välj en app för att läggas till på startsidan",
        "titleRequired": "Korttitel krävs",
        "linkRequired": "Kortlänk krävs",
        "searchPlaceholder": "Sök app"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Introduktionsportal",
        "heading": "Introduktionsportal",
        "subHeading": "Granska din app, introducera nya och dela hanteringsåtkomst med ditt team.",
        "modules": {
            "home": "Hem",
            "apps": "Appar",
            "appsLabel": "Appar",
            "qna": "Q&A",
            "qnaLabel": "Fråga och svar",
            "review": "Granskning",
            "reviewLabel": "Granskning",
            "onboardApp": "Introducera ny app",
            "manageApp": "Hantera appar",
            "defaultApps": "Standardappar",
            "onboardQnA": "Introducera QnA",
            "manageQnA": "Hantera QnA",
            "reviewDashboard": "Granskarpanel",
            "reviewApps": "Granska appar",
            "reviewQnA": "Granska frågor och svar"
        },
        "appOnboardingForm": {
            "formHeading": "Introducera ny app",
            "successAlert": "Appen introducerades framgångsrikt!",
            "appTitleLabel": "App-titel",
            "appTitleTooltip": "App-namn som ska visas",
            "appTitlePlaceholder": "App-namn som ska visas",
            "appTitleError": "App-titel krävs",
            "appSubTitleLabel": "App-underrubrik",
            "appSubTitleTooltip": "App-underrubrik",
            "appSubTitlePlaceholder": "App-underrubrik",
            "appSubTitleError": "App-underrubrik krävs",
            "appUrlLabel": "App-URL",
            "appUrlTooltip": "App-måladress",
            "appUrlPlaceholder": "App-måladress",
            "appUrlError": "App-URL krävs",
            "appKeywordsLabel": "synKeywords (kommaseparerade)",
            "appKeywordsTooltip": "Fyll i synonymer som användare kan använda för att hitta appen och separera dem med komma",
            "appKeywordsPlaceholder": "Fyll i synonymer som användare kan använda för att hitta appen och separera dem med komma",
            "appKeywordsError": "Nyckelord krävs",
            "appCompaniesAllowedLabel": "Tillåtna företag",
            "appCompaniesAllowedTooltip": "Lista över alla företag där den här appen är tillåten. Om tillåten för alla, lämna tomt.",
            "appCompaniesAllowedInfoMessage": "Lista över alla företag där den här appen är tillåten. Om tillåten för alla, lämna tomt.",
            "appCompaniesAllowedOtherLabel": "Andra tillåtna företag",
            "appCompaniesAllowedOtherPlaceholder": "Ange andra tillåtna företag",
            "appCompaniesRestrictedLabel": "Begränsade företag",
            "appCompaniesRestrictedTooltip": "Lista över alla företag där den här appen INTE är tillåten. Om ingen begränsning, lämna tomt.",
            "appCompaniesRestrictedInfoMessage": "Lista över alla företag där den här appen INTE är tillåten. Om ingen begränsning, lämna tomt.",
            "appCompaniesRestrictedOtherLabel": "Andra begränsade företag",
            "appCompaniesRestrictedOtherPlaceholder": "Ange andra begränsade företag",
            "appTooltipLabel": "Tooltip (ange alla språk, om olika namn ska visas)",
            "appTooltipTooltip": "Ange alla språk, om olika namn ska visas, t.ex. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Ange alla språk, om olika namn ska visas, t.ex. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip krävs",
            "appIconLabel": "Ladda upp app-ikon",
            "appIconTooltip": "Ladda upp app-ikon",
            "previewAppBtn": "Förhandsgranska app",
            "cancelBtn": "Avbryt",
            "closeBtn": "Stäng",
            "submitAppBtn": "Skicka in app",
            "updateAppBtn": "Uppdatera app",
            "editAppBtn": "Redigera app",
            "appTitlePreview": "Titel",
            "appSubTitlePreview": "Underrubrik",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Nyckelord",
            "appCompaniesAllowedPreview": "Tillåtna företag",
            "appCompaniesRestrictedPreview": "Begränsade företag",
            "appTooltipPreview": "Tooltip",
            "message": "När en app skickas in får den statusen Väntande och går igenom en definierad granskningslivscykel — från Väntande → Godkänd (under granskning/testning) → I QA (formellt godkänd och verifieras) → I produktion (live och synlig för slutanvändare på MyHelp), eller kan den Avvisas om den inte uppfyller kriterierna; i så fall kan intressenten redigera och skicka in igen."
        },
        "qnaOnboardingForm": {
            "formHeading": "Introducera nytt QnA",
            "successAlert": "QnA introducerades framgångsrikt!",
            "qnaQuestionLabel": "Fråga",
            "qnaQuestionTooltip": "Ange frågan för QnA-objektet",
            "qnaQuestionPlaceholder": "Ange frågan",
            "qnaQuestionError": "Fråga krävs",
            "qnaAnswerLabel": "Svar",
            "qnaAnswerTooltip": "Ange svaret för QnA-objektet",
            "qnaAnswerPlaceholder": "Ange svaret på frågan",
            "qnaAnswerError": "Svar krävs",
            "qnaCategoryLabel": "Kategori",
            "qnaCategoryTooltip": "Välj kategori för QnA-posten",
            "qnaCategoryPlaceholder": "Välj kategori för QnA-posten",
            "qnaCategoryError": "Kategori är obligatorisk",
            "qnaCategoryOtherLabel": "Annan kategori",
            "qnaCategoryOtherPlaceholder": "Ange anpassad kategori",
            "qnaCompaniesAllowedLabel": "Tillåtna företag",
            "qnaCompaniesAllowedTooltip": "Lista över alla företag där den här appen är tillåten. Om tillåten för alla, lämna tomt.",
            "qnaCompaniesAllowedInfoMessage": "Lista över alla företag där den här appen är tillåten. Om tillåten för alla, lämna tomt.",
            "qnaCompaniesAllowedOtherLabel": "Andra tillåtna företag",
            "qnaCompaniesAllowedOtherPlaceholder": "Ange andra tillåtna företag",
            "qnaCompaniesRestrictedLabel": "Begränsade företag",
            "qnaCompaniesRestrictedTooltip": "Lista över alla företag där den här appen INTE är tillåten. Om ingen begränsning, lämna tomt.",
            "qnaCompaniesRestrictedInfoMessage": "Lista över alla företag där den här appen INTE är tillåten. Om ingen begränsning, lämna tomt.",
            "qnaCompaniesRestrictedOtherLabel": "Andra begränsade företag",
            "qnaCompaniesRestrictedOtherPlaceholder": "Ange andra begränsade företag",
            "previewQnABtn": "Förhandsgranska QnA",
            "cancelBtn": "Avbryt",
            "submitQnABtn": "Skicka in QnA",
            "updateQnABtn": "Uppdatera QnA",
            "editQnABtn": "Redigera QnA",
            "addNewQnABtn": "+ Lägg till QnA",
            "qnaQuestionPreview": "Fråga",
            "qnaAnswerPreview": "Svar",
            "qnaCompaniesAllowedPreview": "Tillåtna företag",
            "qnaCompaniesRestrictedPreview": "Begränsade företag",
            "message": "När en Q&A-post skickas in får den statusen Väntande och går igenom en definierad granskningslivscykel — från Väntande → Godkänd (under granskning/testning) → I QA (formellt godkänd och verifieras) → I produktion (live och synlig för slutanvändare på MyHelp), eller kan den Avvisas om den inte uppfyller kriterierna; i så fall kan intressenten redigera och skicka in igen."
        },
        "manageBtn": "Hantera",
        "refreshBtn": "Uppdatera",
        "exportBtn": "Exportera",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Exportera appar som CSV",
        "exportAppsExcelBtn": "Exportera appar som Excel",
        "exportQnACsvBtn": "Exportera QnA som CSV",
        "exportQnAExcelBtn": "Exportera QnA som Excel",
        "approveBtn": "Godkänn",
        "rejectBtn": "Avvisa",
        "toQABtn": "Flytta till QA",
        "toProdBtn": "Flytta till produktion",
        "editBtn": "Redigera",
        "viewBtn": "Visa",
        "closeBtn": "Stäng",
        "dashboard": {
            "appsTitle": "Tillgängliga appar",
            "appsText": "Appar som är tillgängliga för dig via ägarskap eller delning i team.",
            "qnaTitle": "Frågor och svar",
            "qnaText": "Frågor och svar som är tillgängliga för dig via ägarskap eller delning i team."
        },
        "modalLabel": {
            "reviewAppTitle": "Granska app för introduktion",
            "reviewQnATitle": "Granska Q&A för introduktion",
            "owner": "Ägare",
            "createdOn": "Skapad den",
            "status": "Status",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Tillåtna företag",
            "companiesRestricted": "Begränsade företag",
            "keywords": "Nyckelord",
            "reviewerComments": "Granskningskommentarer",
            "category": "Kategori",
            "question": "Fråga",
            "answer": "Svar",
            "mail": "E-post"
        },
        "statusLabel": {
            "pending": "Väntande",
            "approved": "Godkänd",
            "rejected": "Avvisad",
            "onhold": "Pausad",
            "unknown": "Okänd",
            "all": "Alla",
            "inQA": "I QA",
            "inProd": "I produktion"
        },
        "activityLabel": {
            "allowed": "Tillåten",
            "restricted": "Begränsad"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Åtgärd",
            "icon": "Ikon",
            "title": "Titel",
            "subTitle": "Undertitel",
            "question": "Fråga",
            "answer": "Svar",
            "category": "Kategori",
            "owner": "Ägare",
            "description": "Beskrivning",
            "apps": "Appar",
            "qna": "Fråga och svar",
            "defaultApps": "Standardappar",
            "defaultAppsActivity": "Ändringar i standardappar",
            "search": "Sök",
            "selectCompany": "Välj företag",
            "otherCompany": "Namn på annat företag",
            "selectAll": "Välj alla",
            "company": "Företag",
            "update": "Uppdatera",
            "comments": "Kommentarer"
        },
        "noData": {
            "dashboardEmpty": "Inga appar eller Q&A har lagts till",
            "dashboardAppsEmpty": "Inga appar har lagts till",
            "dashboardQnAEmpty": "Inga Q&A har lagts till",
            "reviewDashboardEmpty": "Inga appar eller Q&A har skickats in för granskning.",
            "reviewAppsEmpty": "Inga appar har skickats in för granskning.",
            "reviewQnAEmpty": "Inga Q&A har skickats in för granskning."
        },
        "manageApp": {
            "heading": "Hantera appar",
            "subHeading": "Endast appar du äger eller har beviljats åtkomst till visas här."
        },
        "manageQnA": {
            "heading": "Hantera QnA",
            "subHeading": "Endast QnA du äger eller har beviljats åtkomst till visas här."
        },
        "defaultApps": {
            "heading": "Standardappar",
            "subHeading": "Det här är apparna som finns tillgängliga för alla användare som standard. Du kan ändra vilka appar som visas genom att aktivera eller inaktivera dem.",
            "searchPlaceholder": "Sök efter appar"
        },
        "reviewDashboard": {
            "heading": "Granskningspanel",
            "subHeading": "Granska väntande app-onboardingförfrågningar och godkänn eller avvisa dem. Dina snabba granskningar hjälper oss att behålla en relevant och användbar appsamling för alla."
        },
        "reviewApps": {
            "heading": "Granska appar",
            "subHeading": "Granska väntande app-onboardingförfrågningar och godkänn eller avvisa dem. Dina snabba granskningar hjälper oss att behålla en relevant och användbar appsamling för alla."
        },
        "reviewQnA": {
            "heading": "Granska Q&A",
            "subHeading": "Granska väntande QnA-onboardingförfrågningar och godkänn eller avvisa dem. Dina snabba granskningar hjälper oss att behålla en relevant och användbar QnA-samling för alla."
        },
        "reviewQueue": {
            "heading": "Granskningskö",
            "subHeading": "Granska och godkänn eller avvisa väntande introduktionsbegäranden för appar. Dina snabba granskningar hjälper oss att upprätthålla en relevant och användbar appsamling för alla."
        },
        "activityLog": {
            "heading": "Aktivitetslogg"
        },
        "quickActions": {
            "title": "Snabbåtgärder",
            "onboardNewApp": "Onboarda ny app",
            "manageApps": "Hantera appar",
            "defaultApps": "Standardappar",
            "onboardNewQnA": "Onboarda ny fråga och svar",
            "manageQnA": "Hantera frågor och svar",
            "reviewerDashboard": "Granskarpanel",
            "reviewApps": "Granska onboardade appar",
            "reviewQnA": "Granska onboardade frågor och svar"
        }
    },
    "sourceSelector": {
        "title": "Välj källa",
        "allSources": "Alla källor",
        "allSourcesDesc": "Sök i alla interna E.ON-informationskällor",
        "eonKnowledgeBase": "E.ON Kunskapsbas",
        "eonKnowledgeBaseDesc": "Få tillgång till allmän företagskunskap",
        "eonMyItOrder": "E.ON Mina IT-beställningar",
        "eonMyItOrderDesc": "Hantera och spåra IT-tjänstbeställningar",
        "eonItKnowledgeBase": "E.ON IT-kunskapsbas",
        "eonItKnowledgeBaseDesc": "Hitta IT-relaterad information och lösningar",
        "myGenius": "My Genius",
        "myGeniusDesc": "Utforska interna kurser och läromaterial",
        "confluenceAll": "Confluence (Alla)",
        "confluenceAllDesc": "Sök i samarbetsdokumentation",
        "sharepointAll": "Sharepoint (Alla)",
        "sharepointAllDesc": "Bläddra bland delade filer och resurser",
        "eonApps": "E.ON Appar",
        "eonAppsDesc": "Upptäck och få tillgång till företagsapplikationer",
        "hrPolicies": "HR-policyer",
        "hrPoliciesDesc": "Få tillgång till HR-policyer och riktlinjer",
        "compass": "Compass",
        "compassDesc": "Utforska E.ON Intranät",
        "back": "Tillbaka",
        "search": "Sök...",
        "noMatches": "Inga träffar"
    },
    "ailoader": {
        "thinking": "Tänker",
        "reading": "Läser källor",
        "processing": "Bearbetar",
        "analysing": "Analyserar resultat",
        "preparing": "Förbereder svar",
        "working": "Jobbar på ditt svar – det kan ta en stund."
    },
    "compassScopeSelector": {
        "title": "Välj affärsenhet",
        "iconLabel": "Sökområde",
        "localSearch": "Lokal sökning",
        "compassWideSearch": "Compass-bred sökning",
        "resetToCompassWide": "Återställ till Compass-bred sökning",
        "switchToLocal": "Byt till lokal sökning",
        "localDescription": "Sök inom ditt företag och offentliga inlägg",
        "compassWideDescription": "Sök i alla affärsenheter"
    },
    "errorMessages": {
        "azureAiContentViolation": "Svaret filtrerades på grund av att frågan utlöste Azure OpenAI:s innehållshanteringspolicy. Vänligen ändra din fråga och försök igen."
    }
}
